import { render, staticRenderFns } from "./Professions.vue?vue&type=template&id=43376e42&scoped=true"
import script from "./Professions.vue?vue&type=script&lang=js"
export * from "./Professions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43376e42",
  null
  
)

export default component.exports